/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormatMetadata,
    FormatMetadataFromJSON,
    FormatMetadataFromJSONTyped,
    FormatMetadataToJSON,
    Proxy,
    ProxyFromJSON,
    ProxyFromJSONTyped,
    ProxyToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetMini
 */
export interface AssetMini {
    /**
     * 
     * @type {number}
     * @memberof AssetMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AssetMini
     */
    readonly syncId: string;
    /**
     * 
     * @type {Proxy}
     * @memberof AssetMini
     */
    defaultProxy?: Proxy;
    /**
     * 
     * @type {string}
     * @memberof AssetMini
     */
    readonly type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetMini
     */
    readonly displayName: string;
    /**
     * 
     * @type {FormatMetadata}
     * @memberof AssetMini
     */
    format: FormatMetadata;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AssetMini
     */
    readonly info: { [key: string]: string | undefined; };
    /**
     * 
     * @type {boolean}
     * @memberof AssetMini
     */
    readonly thumbnailGenerated: boolean;
    /**
     * 
     * @type {Array<Proxy>}
     * @memberof AssetMini
     */
    readonly proxies?: Array<Proxy>;
}

export function AssetMiniFromJSON(json: any): AssetMini {
    return AssetMiniFromJSONTyped(json, false);
}

export function AssetMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'syncId': json['sync_id'],
        'defaultProxy': !exists(json, 'default_proxy') ? undefined : ProxyFromJSON(json['default_proxy']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'displayName': json['display_name'],
        'format': FormatMetadataFromJSON(json['format']),
        'info': json['info'],
        'thumbnailGenerated': json['thumbnail_generated'],
        'proxies': !exists(json, 'proxies') ? undefined : ((json['proxies'] as Array<any>).map(ProxyFromJSON)),
    };
}

export function AssetMiniToJSON(value?: AssetMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'default_proxy': ProxyToJSON(value.defaultProxy),
        'format': FormatMetadataToJSON(value.format),
    };
}


